import React from 'react';
import Purchase from '../components/purchase/Purchase';

export default function PurchasePage() {
    return <Purchase />;
}
